// TYPES
import type { FailedResponse, SuccessResponse } from '..'
import { Notification } from 'src/_types/settings'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type UpdateNotifSettingsResponse = SuccessResponse | FailedResponse

export class UpdateNotifSettings extends Request {
    private constructor(userId: string, init?: RequestInit) { super(`${vcBaseUrl}/user/${userId}/settings`, init) }
    static async init(userId: string, body: { notifications: Partial<Notification[]> }, init?: RequestInit) {
        return new UpdateNotifSettings(userId, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(body)
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<UpdateNotifSettingsResponse>(await response.json())
        console.info("Update Notif Settings Results:", data)

        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
